/**
 * Public-brand resolver for WP6-B host-based routing.
 *
 * Decision cascade:
 *   1. Query-param override `?brand=g4` / `?brand=lrs` (preview-env testing).
 *   2. Hostname match → `studio-g4.co.uk` (or any `*.studio-g4.co.uk`
 *      including the Emergent preview URL once DNS resolves) → G4.
 *      `londonrenovationspecialists.com` (or any
 *      `*.londonrenovationspecialists.com`) → LRS.
 *   3. Fallback → `REACT_APP_DEFAULT_PUBLIC_BRAND` (default: `G4`).
 *
 * Resolved once at module load so `isG4` is a stable constant across
 * the App lifecycle (prevents mid-session brand flips during a single
 * React tree render).
 */

const G4_HOST_RE = /(^|\.)studio-g4\.co\.uk$/i;
const LRS_HOST_RE = /(^|\.)londonrenovationspecialists\.com$/i;

function resolveBrand() {
    if (typeof window === "undefined") {
        return (process.env.REACT_APP_DEFAULT_PUBLIC_BRAND || "G4").toUpperCase();
    }
    const qp = new URLSearchParams(window.location.search).get("brand");
    if (qp) {
        const n = qp.trim().toLowerCase();
        if (n === "g4") return "G4";
        if (n === "lrs") return "LRS";
    }
    const host = window.location.hostname || "";
    if (G4_HOST_RE.test(host)) return "G4";
    if (LRS_HOST_RE.test(host)) return "LRS";
    return (process.env.REACT_APP_DEFAULT_PUBLIC_BRAND || "G4").toUpperCase();
}

export const publicBrand = resolveBrand();
export const isG4 = publicBrand === "G4";
export const isLRS = publicBrand === "LRS";
